/**
 * 不同资源不同软件支持的文件格式
 */
const fileTypesMap = {
  COMPONENT: {
    appgarch: ['.gac'],
    appdeco: ['.gac'],
    appgmep: ['.gac'],
    appgroad: ['.gac'],
    appgstr: ['.gac'],
    appgbr: ['.gac'],
    revit: ['.rfa'],
    bimmake: ['.gac'],
    sketchup: ['.skp'],
    acs: ['.excel']
  },
  FILE: [
    '.gap',
    '.gmep',
    '.gst',
    '.gapc',
    '.gmepc',
    '.gstc',
    '.gmc',
    '.rvt',
    '.dwg',
    '.pdf',
    '.dxf',
    '.rte',
    '.nwd',
    '.ifc',
    '.ifczip',
  ],
  PLACEHOLDER: {
    appgarch: ['.gac'],
    appgmep: ['.gac'],
    appgroad: ['.gac'],
    appgstr: ['.gac'],
    design: ['.gac']
  },
  MODULE: {
    appgmep: ['.gmed'],
    appgstr: ['.gmd'],
    appgarch: ['.gmd']
  },
  SCHEME: {
    appgbr: ['.gnbt'],
  },
  TEMPLATE: {
    revit: ['.rte'],
    autocad: ['.dwt']
  },
  DRAWING: {
    autocad: ['.dwg']
  },
  MODEL: {
    gap: ['AppGarch'],
    gapc: ['AppGarch'],
    gmep: ['AppGmep'],
    gmepc: ['AppGmep'],
    gst: ['AppGstr'],
    gstc: ['AppGstr'],
  }
}
const getFileTypes = (resourceType, software) => {
  if (resourceType) {
    if (resourceType === 'FILE') {
      return fileTypesMap[resourceType]
    }
    resourceType = resourceType.toUpperCase()
    software = software.toLowerCase()
    return fileTypesMap[resourceType][software] || []
  }
}

/**
 * 不同软件code对应的中文名字
 */
const softwaresMap = {
  appgarch: '广联达数维建筑设计',
  appgmep: '广联达数维机电设计',
  appgroad: '广联达数维道路设计',
  appgstr: '广联达数维结构设计',
  appgbr: '广联达数维桥梁设计',

}
const getSoftwareCn = (code) => {
  if (code) {
    code = code.toLowerCase()
    return softwaresMap[code]
  }
}
/**
 * 上传不同资源
 */
const resourcesMap = {
  COMPONENT: '构件',
  PLACEHOLDER: '图例',
  MODULE: '模块',
  SCHEME: '模板',
  FONT: '字体',
  TEMPLATE: '样板',
  DRAWING: '图纸',
  DRAWING_FRAME: '图框',
}
const getResourceType = (code) => {
  if (code) {
    code = code.toUpperCase()
    return resourcesMap[code]
  }
}
const platformCodeMap = {
  NOVA_DESIGN: ['AppGarch', 'AppGstr', 'AppGmep', 'AppGroad'],
  REVIT: ['revit'],
  AUTOCAD: ['AutoCAD']
}
const getSoftwareCodesByPlatformCode = (platformCode) => {
  if (platformCode) {
    platformCode = platformCode.toUpperCase()
    return platformCodeMap[platformCode][0]
  }
}

const cadVersionMap = {
  AC1032: '2018',
  AC1027: '2013',
  AC1024: '2010',
  AC1021: '2007',
  AC1018: '2004',
  AC1015: '2000',
  AC1014: '14',
  AC1012: '13',
  AC1009: '11',
  AC1006: '10',
  AC1004: '9',
  AC1002: '2',
}

const getCADVersionMap = (code) => {
  if (code) {
    return cadVersionMap[code]
  }
}
const revitVersionMap = {
  2014: 2014,
  2015: 2015,
  2016: 2016,
  2017: 2017,
  2018: 2018,
  2019: 2019,
  2020: 2020,
  2021: 2021,
  2022: 2022,
  2023: 2023,
  2024: 2024,
  2025: 2025,
}

const getRevitVersionMap = (code) => {
  if (code) {
    return revitVersionMap[code]
  }
}

export { getFileTypes, getResourceType, getSoftwareCn, getSoftwareCodesByPlatformCode, getCADVersionMap, getRevitVersionMap }

